import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import RotationRole from '../charts/RotationRole';
import {
  StyledCard,
  StyledCardTitle,
  StyledContainer,
  StyledContent,
  StyledHeader,
  StyledHighlight,
  StyledHighlightList,
  StyledHighlightValue,
  StyledSource,
  StyledWrapper
} from './SuccessRate.styled';

const Rotation: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  const rotationData = [
    {
      value: 4,
      desc: t('state-of-hiring.success-rate.rotation.replacement-rate')
    },
    {
      value: 15,
      desc: t('state-of-hiring.success-rate.rotation.rotation-average-manfred')
    },
    {
      value: 19,
      desc: t('state-of-hiring.success-rate.rotation.rotation-average-industry')
    }
  ];

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <Heading2 editorial>
            {t('state-of-hiring.success-rate.rotation.title')}
          </Heading2>
        </StyledHeader>

        <StyledContent className="reverse">
          <div>
            <div className="text-lg">
              <HtmlTrans
                i18nKey="state-of-hiring.success-rate.rotation.content"
                ns="state-of-hiring"
              />
            </div>
          </div>
          <div>
            <StyledCard>
              <StyledCardTitle>
                {t('state-of-hiring.success-rate.rotation.rol-title')}
              </StyledCardTitle>
              <RotationRole />
            </StyledCard>
          </div>
        </StyledContent>
        <StyledHighlightList>
          {rotationData.map((item, index) => (
            <StyledHighlight key={index}>
              <StyledHighlightValue>{item.value}%</StyledHighlightValue>
              <span>{item.desc}</span>
            </StyledHighlight>
          ))}
        </StyledHighlightList>
        <StyledSource>
          <strong>*{t('state-of-hiring.success-rate.rotation.source')}:</strong>{' '}
          {t('state-of-hiring.success-rate.rotation.source-name')}
        </StyledSource>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Rotation;
